import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errors = {
	state: {	
		favoritos : []
	},
	getters: {		
		getFavoritos : state => state.favoritos
	},
	actions: {
		toggleFavoritos : function({commit,state},el){
			let exits = state.favoritos.some(e => e.idPractica == el.idPractica);

			(exits) ? commit('removeFavorito',el) : commit('addFavorito',el);
		}
	},
	mutations: {
		setFavoritos(state){
			if(!!window.localStorage.getItem('favs')){
				state.favoritos = JSON.parse(window.localStorage.getItem('favs'));
			}
		},
		addFavorito(state,el){
			let ele = {
				idPractica : el.idPractica,
				nombreEstudiante : el.nombreEstudiante,
				nombreEmpresa : el.nombreEmpresa,
				puesto : el.puesto
			};

			state.favoritos.push(ele);
			window.localStorage.setItem('favs', JSON.stringify(state.favoritos));
		},
		removeFavorito(state,el){
			let favs = new Array();

			state.favoritos.forEach(e => {
				if(e.idPractica != el.idPractica){
					favs.push(e);
				}
			})

			state.favoritos = favs;

			window.localStorage.setItem('favs', JSON.stringify(state.favoritos));
		}
	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/favoritos.js